import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { NetworkConstants } from 'diwimamodelweb/lib';
import { removeUndefined } from 'diwimamodelweb/lib/utils/obejct-diff';
import { BaseSettingForm } from '../model/form';
import { firstValueFrom, skipWhile, take } from 'rxjs';
import { SettingsService } from '../settings.service';

@Component({
  selector: 'app-setting-form-base',
  templateUrl: './setting-form-base.component.html',
  styleUrls: ['./setting-form-base.component.css', '../../app.component.scss']
})
export class SettingFormBaseComponent implements OnInit {

  @Input() data: BaseSettingForm
  @Input() formBuilder: FormBuilder
  @Input() translateService: TranslateService
  // @Input() settingsService: SettingsService

  settingForm: FormGroup
  hideCommentField = true
  isCreate = false
  deleteRight = false
  updateRight = false
  hideColorPicker = false

  constructor(private settingsService: SettingsService) { }

  async ngOnInit(): Promise<void> {
    console.log(this.data)
    if (!this.data.data) this.isCreate = true

    const context = await firstValueFrom(this.settingsService.selectedUserContext$.pipe(
      skipWhile(el => !el),
      take(1)
    ))
    const rights = this.settingsService.rightsPercontext.get(context.identifier)
    this.updateRight = !rights?.[NetworkConstants.ROUTE_CTX_SETTINGS]?.['U'] ?? false
    this.deleteRight = !rights?.[NetworkConstants.ROUTE_CTX_SETTINGS]?.['D'] ?? false
    
    this.settingForm = this.formBuilder.group({
      title: [, Validators.required],
      comment: [],
      color: [],
      colorOpacity: [100]
    })
    if (this.data.data) this.initialitzeWithData()
    const {settingId} = this.data
    switch (settingId) {
      case NetworkConstants.SETTING_HUNTING_METHODS:{
        this.hideColorPicker = true
        break
      }
      
      case NetworkConstants.SETTING_GEO_USAGE_STATUS:{
        this.hideColorPicker = true
        break
      }

      case NetworkConstants.SETTING_COLLECTIVE_SPECIES:{
        this.hideColorPicker = true
        break
      }
      case NetworkConstants.SETTING_GR_LOCATION:{
        this.hideColorPicker = true
        break
      }
      // case NetworkConstants.SETTING_GR_STATUS:{
      //   this.hideColorPicker = false
      //   break
      // }
      case NetworkConstants.SETTING_LAB_SAMPLE_LOCATION:{
        this.hideColorPicker = true
        break
      }
      case NetworkConstants.SETTING_LAB_SAMPLE_STATUS:{
        this.hideColorPicker = true
        break
      }
      case NetworkConstants.SETTING_LAB_SAMPLE_TYPE:{
        this.hideColorPicker = true
        break
      }

      case NetworkConstants.SETTING_GR_MEAT_QUALITY:{
        this.hideColorPicker = true
        this.hideCommentField = false
        break
      }
      case NetworkConstants.SETTING_GR_SHOT_QUALITY: {
        this.hideCommentField = false
        this.hideColorPicker = true
        break
      }

      case NetworkConstants.SETTING_UTILIZATION_OPTION:{
        this.hideColorPicker = true
        break
      }
      case NetworkConstants.SETTING_TROPY_TYPE:{
        this.hideColorPicker = true
        break
      }
      case NetworkConstants.SETTING_READOUT_GROUPS:{
        this.hideColorPicker = true
        break
      }
    }
    this.settingForm.valueChanges.subscribe((value) => {

    })
  }

  initialitzeWithData() {
    const {title, comment, color} = this.data.data
    let newColor,newcolorOpacity
    if(color?.length > 6 ){
     newColor = color.slice(0,7)
      newcolorOpacity = this.convertHexToOpacityslider(color.slice(7,9))
      if(newcolorOpacity)
        this.settingForm.patchValue({colorOpacity: newcolorOpacity})

    }else{
      this.settingForm.patchValue({colorOpacity: 100})

    }
    // if (color) this.hideColorPicker = false
    if (this.data.settingId == NetworkConstants.SETTING_COLLECTIVE_SPECIES) {
      const t = (this.data.data as any).names?.de
      this.settingForm.patchValue({title: t, comment, color: newColor ? newColor : color})
    } else {
      this.settingForm.patchValue({title, comment, color: newColor ? newColor : color})
    }
  }

  onSubmit() {
    const {title, comment, color} = this.settingForm.value
    if (this.isCreate) {
      let setting: any;
      if (this.data.settingId == NetworkConstants.SETTING_COLLECTIVE_SPECIES) {
        setting = {
          identifier: title,
          names: {de: title},
          sortOrder: 999
        }
      } else {
        setting = {
          identifier: title,
          title,
          // comment,
          // color,
          sortOrder: 999
        }
        if (comment) setting['comment'] = comment
        if (color) setting['color'] = color

        if(this.hideColorPicker)
        setting['color'] = undefined
      }
      const cleaned = removeUndefined(setting)
      this.data.onCreate(cleaned)
    } else {
      if (this.data.settingId == NetworkConstants.SETTING_COLLECTIVE_SPECIES) {
        // setting this.data.data.names.de... 
        this.data.data.names.de = title
      } else {
        this.data.data.title = title
        if (comment) this.data.data.comment = comment
        if (color) this.data.data.color = color
      }

      if(this.hideColorPicker)
        delete this.data.data.color 

      if(this.settingForm.value.color && this.settingForm.value.colorOpacity){
        let opacity = this.convertOpacityToHex(this.settingForm.value.colorOpacity)
        this.data.data.color += opacity
      }      
      this.data.onSubmit()
    }
  }

  onDelete(){
    this.data.onDelete(this.data)
  }

  convertOpacityToHex(opacity){
    opacity = Math.min(100, Math.max(0, opacity));
    let hex = Math.round(opacity * 255 / 100);
    return hex.toString(16).padStart(2, '0');
  }

  convertHexToOpacityslider(hex){
    let decimal = parseInt(hex, 16);
    let percent = Math.round((decimal / 255) * 100);
    return percent ? percent : undefined;
  }
}
